import { useFeatureDisableByChainOrWhitelist } from 'hooks/flags/useFeatureDisableByChainOrWhitelist';

export function useIsRampPageDisabledFlag(): boolean {
  return useFeatureDisableByChainOrWhitelist('ramp_page_disabled');
}
